import { INote } from '@/interfaces/notes';

export const getNotes = async (noteId?: string) => {
  const url = noteId
    ? `${import.meta.env.VITE_API_URL}/notes?id=${noteId}`
    : `${import.meta.env.VITE_API_URL}/notes`;

  const response = await fetch(url);
  const responseData = await response.json();

  return noteId ? (responseData as INote) : (responseData as Array<INote>);
};
